"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _awsAmplify = require("aws-amplify");

var _RestoreForm = _interopRequireDefault(require("./RestoreForm"));

var _IndexModule = _interopRequireDefault(require("../../Index.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var RestorePassword = function RestorePassword(_ref) {
  var loading = _ref.loading,
      userName = _ref.userName,
      setActiveResetPassword = _ref.setActiveResetPassword,
      setLoading = _ref.setLoading,
      setUserName = _ref.setUserName;

  var _useState = (0, _react.useState)(""),
      _useState2 = _slicedToArray(_useState, 2),
      code = _useState2[0],
      setCode = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      codeSent = _useState4[0],
      setCodeSent = _useState4[1];

  var _useState5 = (0, _react.useState)(""),
      _useState6 = _slicedToArray(_useState5, 2),
      newPassword = _useState6[0],
      setNewPassword = _useState6[1];

  var _useState7 = (0, _react.useState)(""),
      _useState8 = _slicedToArray(_useState7, 2),
      confirmPassword = _useState8[0],
      setConfirmPassword = _useState8[1];

  var _useState9 = (0, _react.useState)(""),
      _useState10 = _slicedToArray(_useState9, 2),
      alertMessage = _useState10[0],
      setAlertMessage = _useState10[1];

  var _useState11 = (0, _react.useState)(""),
      _useState12 = _slicedToArray(_useState11, 2),
      alertType = _useState12[0],
      setAlertType = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = _slicedToArray(_useState13, 2),
      showAlert = _useState14[0],
      setShowAlert = _useState14[1];

  var _useState15 = (0, _react.useState)(""),
      _useState16 = _slicedToArray(_useState15, 2),
      userNameValidate = _useState16[0],
      setUserNameValidate = _useState16[1];

  var _useState17 = (0, _react.useState)(""),
      _useState18 = _slicedToArray(_useState17, 2),
      codeValidate = _useState18[0],
      setCodeValidate = _useState18[1];

  var _useState19 = (0, _react.useState)(""),
      _useState20 = _slicedToArray(_useState19, 2),
      newPasswordValidate = _useState20[0],
      setNewPasswordValidate = _useState20[1];

  var _useState21 = (0, _react.useState)(""),
      _useState22 = _slicedToArray(_useState21, 2),
      confirmPasswordValidate = _useState22[0],
      setConfirmPasswordValidate = _useState22[1];

  var _useState23 = (0, _react.useState)(false),
      _useState24 = _slicedToArray(_useState23, 2),
      isTempBlocked = _useState24[0],
      setIsTempBlocked = _useState24[1];

  var _useState25 = (0, _react.useState)(false),
      _useState26 = _slicedToArray(_useState25, 2),
      disabledButton = _useState26[0],
      setDisabledButton = _useState26[1];

  var handleResetPassword = function handleResetPassword() {
    setShowAlert(true);

    if (userNameValidate !== "success") {
      setAlertType("error");
      if (userName.length === 0) setAlertMessage("Este campo es obligatorio");else setAlertMessage("Ingrese un correo válido");
    } else {
      setCodeSent(true);

      _awsAmplify.Auth.forgotPassword(userName).then(function () {}
      /** data */
      )["catch"](function (err) {
        // console.log(err)
        if (err.code === "LimitExceededException") {
          setIsTempBlocked(true);
          setAlertType("error");
          setAlertMessage("Usuario blockeado temporalmente por exceder limite de intentos, prueba más tarde");
        }
      });

      setAlertType("info");
      setAlertMessage("Si su usuario es valido, será enviado a su correo un código de validación");
    }
  };

  var handleConfirmResetPassword = function handleConfirmResetPassword() {
    setDisabledButton(true);
    setShowAlert(true);

    if (code.length === 0 || newPassword.length === 0 || confirmPasswordValidate.length === 0) {
      setAlertType("error");
      setAlertMessage("Todos los campos son obligatorios");
      setDisabledButton(false);
      return;
    }

    if (code.trim().length < 6) {
      setAlertType("error");
      setAlertMessage("Hubo un error con su codigo, intentelo nuevamente");
      setDisabledButton(false);
      return;
    }

    if (newPassword.trim().length < 10 || confirmPassword.trim().length < 10) {
      setAlertType("error");
      setAlertMessage("Hubo un error, inténtelo de nuevo. Recuerda que las contraseñas son mínimo 10 caracteres");
      setDisabledButton(false);
      return;
    }

    _awsAmplify.Auth.forgotPasswordSubmit(userName, code, newPassword).then(function () {
      // data
      setAlertMessage("Ha cambiado su contraseña correctamente. Por favor, inicie sesión con sus nuevas credenciales");
      setLoading(true);
      setAlertType("success");
      setTimeout(function () {
        setUserName("");
        setCode("");
        setNewPassword("");
        setConfirmPassword("");
        setActiveResetPassword(false);
        setLoading(false);

        _antd.notification.success({
          message: "Su contraseña se ha cambiado exitosamente"
        });

        setDisabledButton(false);
      }, 5000);
    })["catch"](function () {
      // err
      setAlertMessage("Hubo un error, intentelo más tarde");
      setDisabledButton(false);
      setAlertType("error");
    });
  };

  var handleUserNameValidation = function handleUserNameValidation(e) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var status = re.test(String(e.target.value).toLowerCase());
    status ? setUserNameValidate("success") : setUserNameValidate("error");
  };

  var handleAlreadyHavePassword = function handleAlreadyHavePassword() {
    setShowAlert(true);

    if (userNameValidate !== "success") {
      setAlertType("error");
      if (userName.length === 0) setAlertMessage("El campo es obligatorio");else setAlertMessage("Ingrese un correo válido");
    } else {
      setCodeSent(true);
      setAlertType("info");
      setAlertMessage("Ingrese el código y su nueva contraseña");
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h4", {
    style: {
      width: "80%",
      color: "rgba(89,116,175,1)",
      fontWeight: "bold",
      textAlign: "center",
      padding: "10px 0px"
    }
  }, "Ingresa tus datos para restablecer contrase\xF1a"), showAlert && /*#__PURE__*/_react["default"].createElement("div", {
    className: _IndexModule["default"].loginAlerts
  }, /*#__PURE__*/_react["default"].createElement(_antd.Alert, {
    message: alertMessage,
    type: alertType,
    showIcon: true
  })), !codeSent ? /*#__PURE__*/_react["default"].createElement(_antd.Form, {
    name: "resetPassword",
    className: _IndexModule["default"].loginForm
  }, /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, {
    name: "username",
    hasFeedback: true,
    validateStatus: userNameValidate
  }, /*#__PURE__*/_react["default"].createElement(_antd.Input, {
    prefix: /*#__PURE__*/_react["default"].createElement(_icons.UserOutlined, {
      className: "site-form-item-icon"
    }),
    value: userName,
    className: _IndexModule["default"].customeInput,
    placeholder: "Usuario",
    onChange: function onChange(e) {
      return setUserName(e.target.value.trim());
    },
    onKeyUp: handleUserNameValidation
  })), /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, null, /*#__PURE__*/_react["default"].createElement(_antd.Button, {
    id: "submit-btn",
    htmlType: "submit",
    type: "ghost",
    block: true,
    className: _IndexModule["default"].loginButton,
    loading: loading,
    onClick: handleResetPassword
  }, "Enviar"), /*#__PURE__*/_react["default"].createElement(_antd.Button, {
    type: "link",
    className: _IndexModule["default"].resetButton,
    onClick: handleAlreadyHavePassword
  }, "Ya tengo mi c\xF3digo"))) : /*#__PURE__*/_react["default"].createElement(_RestoreForm["default"], {
    code: code,
    codeValidate: codeValidate,
    confirmPassword: confirmPassword,
    confirmPasswordValidate: confirmPasswordValidate,
    disabledButton: disabledButton,
    setDisabledButton: setDisabledButton,
    handleConfirmResetPassword: handleConfirmResetPassword,
    loading: loading,
    newPassword: newPassword,
    newPasswordValidate: newPasswordValidate,
    setCode: setCode,
    setCodeValidate: setCodeValidate,
    setConfirmPassword: setConfirmPassword,
    setConfirmPasswordValidate: setConfirmPasswordValidate,
    setNewPassword: setNewPassword,
    setNewPasswordValidate: setNewPasswordValidate,
    userName: userName,
    isTempBlocked: isTempBlocked
  }), /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, null, !loading && /*#__PURE__*/_react["default"].createElement(_antd.Button, {
    type: "link",
    className: _IndexModule["default"].resetButton,
    onClick: function onClick() {
      setActiveResetPassword(false);
      setCodeSent(false);
    }
  }, "Volver")));
};

var _default = RestorePassword;
exports["default"] = _default;